import { useQuery } from "convex/react";
import { anyApi } from "convex/server";
import { RentLedger, type RentSummary } from "./RentLedger";
import { useImpersonatedUnitId } from "../lib/view-as-context";

// Tenant-facing rent ledger card on the Dashboard. Read-only view
// of the caller's currently-active lease. New lease starts -> the
// ledger here resets to that lease's months; the prior lease's
// payment history doesn't leak across.
//
// When a landlord is impersonating a tenant of a specific unit, we
// pass that unit to the query so it resolves to that unit's active
// lease instead of looking up the (nonexistent) landlord tenancy.
export function MyRentSection() {
  const impersonatedUnitId = useImpersonatedUnitId();
  const summary = useQuery(
    anyApi.rent.myCurrentRent,
    impersonatedUnitId ? { onBehalfOfUnitId: impersonatedUnitId } : {},
  ) as RentSummary | null | undefined;

  return (
    <section className="rounded-xl border border-slate-200 bg-white">
      <header className="px-6 pt-5 pb-4 border-b border-slate-100">
        <h2 className="text-base font-semibold text-slate-900">Rent</h2>
        <p className="mt-0.5 text-sm text-slate-500">
          Monthly status for your current lease.
        </p>
      </header>
      {summary === undefined ? (
        <p className="px-6 py-4 text-sm text-slate-500">Loading…</p>
      ) : (
        <RentLedger summary={summary} />
      )}
    </section>
  );
}
